/**
 * 能力注册表（声明式课程门禁的唯一事实源）。
 *
 * - 站点（workbench_sites）本身不设门禁；能力按课程报名门禁
 * - "报过名即可"语义：registered / in_class / finished 均解锁，dropout 关闭
 * - 员工（非 student 角色）不受课程门禁
 * - 三处消费同一份声明：导航可见性 / 路由守卫 / handler 校验
 */
export const CAPABILITY_GATES = {
  "site-tools": { requiresCourseCode: "wp", label: "建站工具" },
  "sio-tools": { requiresCourseCode: "sio", label: "推广工具" },
  "design-templates": { requiresCourseCode: "wp", label: "设计参考" },
} as const;

export type CapabilityId = keyof typeof CAPABILITY_GATES;

export const ALL_CAPABILITY_IDS = Object.keys(CAPABILITY_GATES) as CapabilityId[];

/** 报名状态 → 是否解锁能力（报过名即可，毕业保留） */
export const ENROLLMENT_STATUSES_UNLOCKING_CAPABILITIES = [
  "registered",
  "in_class",
  "finished",
] as const;
